const GENRE_ENUM = ["Pop", "Hip-Hop", "Rap", "Rock", "Dance", "Electronic", "Latin", "Indie", "Alternative", "Classic", "Country", "Metal","Jazz","Ambient", "Other"]

export default GENRE_ENUM;